import { VerificationType } from '../../../constants.js';
import enMessages from '../../../i18n/form/en.js';
import ruMessages from '../../../i18n/form/ru.js';

export const MESSAGES = {
  en: enMessages,
  ru: ruMessages,
};

export const FORM_TEXTAREA_MAXLENGTH = 256;

export const FILE_STATUSES = {
  default: 'default',
  error: 'error',
  finish: 'finish',
  process: 'process',
  success: 'success',
};

export const MAX_COUNT_FILES = 10;
export const UPLOADED_FILES = [];

export const FORM_FIELDS = {
  companyName:'',
  companyIdentificationNumber: '',
  confirmation: false,
  contactName: '',
  contactSurname: '',
  contactPatronymic: '',
  descriptionActivity: '',
  email: '',
  files: '',
  phone: '',
  website: '',
};

export const verificationFormType = typeof window !== 'undefined' && window.GATSBY_VERIFICATION_TYPE_FOR_SITE_COMPANY_FORM 
? window.GATSBY_VERIFICATION_TYPE_FOR_SITE_COMPANY_FORM
: process.env.GATSBY_VERIFICATION_TYPE_FOR_SITE_COMPANY_FORM || VerificationType.Email; 
